import {seamlessBootstrap, seamlessImmutable} from 'epic-alt-utils/index';

import Immutable from 'seamless-immutable';
import SubscriptionActions from '../actions/SubscriptionActions';
import SubscriptionSource from '../sources/SubscriptionSource';
import alt from '../alt';
import {datasource} from 'alt-utils/lib/decorators';

@datasource(SubscriptionSource)
@seamlessImmutable
class SubscriptionStore {
    constructor() {
        this.on('error', (error) => {
            console.error(error);
        });
        this.on('bootstrap', seamlessBootstrap.bind(this, null));
        this.state = Immutable({
            error: null,
            isSubscribed: false,
            optOutLink: ''
        });
        this.bindActions(SubscriptionActions);
    }

    onGetStatus(email) {
        if (!this.state.isSubscribed) {
            this.getInstance().getStatus(email);
        } else {
            console.log('User has already been subscribed');
        }
    }

    onGetStatusSuccess({data}) {
        if (data.productSubscribed) {
            this.setState(this.state.merge({
                loading: false,
                isSubscribed: true
            }));
        } else {
            this.setState(this.state.merge({
                loading: false,
                isSubscribed: false
            }));
        }
    }

    onGetStatusFailure(error) {
        this.setState(this.state.merge({
            loading: false,
            error: true
        }));
    }

    onSubscribe(email) {
        if (!this.state.isSubscribed) {
            this.getInstance().subscribe(email);
        } else {
            console.log('User has already been subscribed');
        }
    }

    onSubscribeSuccess(response) {
        if (response.data) {
            console.log('Subscribed successfully');
            this.setState(this.state.merge({
                loading: false,
                isSubscribed: true
            }));
        } else {
            console.error('fail to subscribe newsletter');
            this.setState(this.state.merge({
                error: true,
                loading: false
            }));
        }
    }

    onSubscribeFailure(error) {
        this.setState(this.state.merge({
            loading: false,
            error: true
        }));
    }

    onGetOptOutLink() {
        this.getInstance().getOptOutLink();
        this.setState(this.state.merge({
            loading: true
        }));
    }
    
    onGetOptOutLinkSuccess(response) {
        if (response.data) {
            this.setState(this.state.merge({
                loading: false,
                optOutLink: response.data.optOutLink
            }));
        } else {
            console.error('failed to get OptOutLink');
            this.setState(this.state.merge({
                loading: false,
                error: true
            }));
        }
    }

    onGetOptOutLinkFailure(error) {
        console.error('failed to retrieve optOutLink', error);
        this.setState(this.state.merge({
            loading: false,
            error: true
        }));
    }
}

export default alt.createStore(SubscriptionStore, 'SubscriptionStore');

